import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ProfessionalService {
  private readonly API = `${environment.apiUrl}/professionals`;
  constructor(private http: HttpClient) {}

  getAll(): Observable<any[]>             { return this.http.get<any[]>(this.API); }
  getById(id: number): Observable<any>    { return this.http.get<any>(`${this.API}/${id}`); }
  create(data: any): Observable<any>      { return this.http.post<any>(this.API, data); }
  update(id: number, d: any): Observable<any> { return this.http.put<any>(`${this.API}/${id}`, d); }
  delete(id: number): Observable<any>     { return this.http.delete(`${this.API}/${id}`); }

  toggleStatus(id: number, isActive: boolean): Observable<any> {
    return this.http.put(`${this.API}/${id}/toggle-status`, { isActive });
  }

  getBilling(id: number): Observable<any>        { return this.http.get<any>(`${this.API}/${id}/billing`); }
  saveBilling(id: number, d: any): Observable<any> { return this.http.post<any>(`${this.API}/${id}/billing`, d); }
  getSubscription(id: number): Observable<any>   { return this.http.get<any>(`${this.API}/${id}/subscription`); }

  getUsers(id: number): Observable<any[]>  { return this.http.get<any[]>(`${this.API}/${id}/users`); }
  addUser(id: number, userId: number, role: string, permissions?: string): Observable<any> {
    return this.http.post(`${this.API}/${id}/users`, { userId, role, permissions });
  }
  removeUser(professionalId: number, userId: number): Observable<any> {
    return this.http.delete(`${this.API}/${professionalId}/users/${userId}`);
  }

  // Agendamentos do profissional (usado no dashboard)
  getAppointments(id: number, startDate?: Date, endDate?: Date): Observable<any[]> {
    let params = new HttpParams();
    if (startDate) params = params.set('startDate', startDate.toISOString());
    if (endDate)   params = params.set('endDate',   endDate.toISOString());
    return this.http.get<any[]>(`${this.API}/${id}/appointments`, { params });
  }

  // Pacientes do profissional (usado no dashboard)
  getPatients(id: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.API}/${id}/patients`);
  }
}
